import React, { Component } from "react"
import { Link, withRouter } from "react-router-dom"
import { SideMenu, NavDropdownButton, Footer } from "../components"
import * as constants from "../constants"
class Layout extends Component {
  render() {
    var userLinks = [
      { label: "Personalizar relatórios", link: "/personalizarelatorios" },
      {
        label: "Atualizar meus dados",
        link: `/usuarios/edit/${constants.getUserID()}`
      },
      { label: "Logout", link: "/logout" }
    ]
    return (
      <div>
        <SideMenu linkActive={this.props.tabActive} />
        <div className="main-panel">
          <nav className="navbar navbar-transparent navbar-absolute">
            <div className="container-fluid">
              <div className="navbar-header">
                <button
                  type="button"
                  className="navbar-toggle"
                  data-toggle="collapse"
                >
                  <span className="sr-only">Toggle navigation</span>
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                  <span className="icon-bar" />
                </button>
              </div>

              <div className="collapse navbar-collapse">
                <ul className="nav navbar-nav navbar-right">
                  {constants.haveRole(1)&& (
                    <li className='d-none'>
                      <Link
                        to="/tce"
                        title="Importar dados do TCE"
                        className="dropdown-toggle"
                      >
                        <i className="material-icons">input</i>
                      </Link>
                    </li>
                  )}
                  <li>
                    <Link
                      to="/"
                      title="Ir para dashboard"
                      className="dropdown-toggle"
                    >
                      <i className="material-icons">dashboard</i>
                    </Link>
                  </li>
                  <NavDropdownButton
                    isUser={true}
                    links={userLinks}
                    label="Profile"
                    icon="person"
                    badge={0}
                  />
                </ul>
              </div>
            </div>
          </nav>

          <div style={{ minHeight: "71vh" }} className="content">
            {this.props.children}
          </div>
          {constants.getCidade() === "Juazeiro do Norte" && <Footer />}
        </div>
      </div>
    )
  }
}
export default withRouter(Layout)



// WEBPACK FOOTER //
// ./src/views/Layout.js